import {Injectable} from '@angular/core';

import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../../../../environments/environment';
import {switchMap} from 'rxjs/operators';
import {RegionNsosData} from '../../../../../types/nso-data-portal/dashboard-data';
import {SearchEntityLevels} from '../../../../../types/nso-data-portal/search-entity-levels';
import {LiveCountData} from '../../../../../types/nso-data-portal/live-count-data';
import {RegionInformationRestService} from '../../region-information-rest.service';

@Injectable()
export class ScoutDonateRestService {

  private readonly LIVE_COUNT_API = '/projects/liveCount';

  constructor(private http: HttpClient,
              private regionService: RegionInformationRestService) {
  }

  getLiveCount(organizationName: string): Observable<LiveCountData> {
      const params = new HttpParams()
        .set('type', SearchEntityLevels.ORGANIZATION)
        .set('orgName', organizationName);
      return this.http.get<LiveCountData>(environment.sdpApiUrl + this.LIVE_COUNT_API, {params});
  }

  getLiveCountForWorld() {
    const params = new HttpParams().set('type', SearchEntityLevels.WORLD);
    return this.http.get<LiveCountData>(environment.sdpApiUrl + this.LIVE_COUNT_API, {params});
  }

  getLiveCountForRegion(regionId: number): Observable<LiveCountData> {
    return this.regionService.getRegionNsoNames(regionId).pipe(
      switchMap((res: RegionNsosData[]) => {
        const params = new HttpParams()
          .set('type', SearchEntityLevels.REGION)
          .set('orgName', JSON.stringify(res.map(e => e.name)));
        return this.http.get<LiveCountData>(environment.sdpApiUrl + this.LIVE_COUNT_API, {params});
      })
    );
  }
}
